import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { buildBookingUrl, buildClientRegistrationUrl } from "../utils/urlUtils";

const TABLET_MORE_DRAWER_OFFSET = "calc(84px + env(safe-area-inset-bottom))";

export function getTabletMoreDrawerPaperStyles() {
  return {
    bottom: TABLET_MORE_DRAWER_OFFSET,
    height: "min(72dvh, 640px)",
    maxHeight: `calc(100dvh - ${TABLET_MORE_DRAWER_OFFSET})`,
    borderTopLeftRadius: 22,
    borderTopRightRadius: 22,
    overflow: "hidden",
  };
}

export function getSidebarQuickActionItems() {
  return [
    {
      key: "booking",
      title: "Booking link",
      description: "Copy your public booking page for clients.",
      successMessage: "Booking link copied!",
      errorMessage: "Failed to copy link",
      Icon: ContentCopyIcon,
      buildUrl: buildBookingUrl,
    },
    {
      key: "client-registration",
      title: "Client intake link",
      description: "Send the registration form before the first visit.",
      successMessage: "Registration link copied!",
      errorMessage: "Failed to copy link",
      Icon: PersonAddAlt1Icon,
      buildUrl: buildClientRegistrationUrl,
    },
  ];
}
